/*@ngInject*/
const UIAutoClosePopoverDirective = function ($timeout, $document, $window, coreConstant) {

    let linkFunction = function ($scope, $elm) {

        const element = $($elm);
        const window = $($window);

        function onClick(event) {
            const popoverParentElement = $(`.${$scope.parentClassName}`);
            const popoverMenuElement = $(`.umPopover.${$scope.dropdownPopoverClassName}`);
            const searchInputElement = $('um-dropdown-search');
            const isInteractingOutsideDropdown = element[0] === event.target;
            const isScrolling = event.type === 'mousewheel' || event.type === 'DOMMouseScroll';
            const isClickingParentContainer = popoverParentElement.find(event.target).length !== 0;
            const isClickingPopoverMenuChild = popoverMenuElement.find(event.target).length !== 0;
            const isClickingSearchInput = searchInputElement.find(event.target).length !== 0;
            const isClickingPopoverMenu = popoverMenuElement[0] === event.target;
            const isClickingOutsideOptionList = !(isClickingPopoverMenuChild || isClickingParentContainer || isClickingPopoverMenu || isInteractingOutsideDropdown);

            if (isClickingOutsideOptionList) {
                closeDropdown(event);
            } else if (!isScrolling && !isClickingSearchInput && (isClickingPopoverMenuChild || isClickingPopoverMenu)) {
                event.preventDefault();
            }
        }

        function closeDropdown(event) {
            $scope.onClose({event: event});
        }

        // use timeout to avoid handling the event on initialization
        // since its triggered on a click
        $timeout(() => {
            $scope.$on(coreConstant.event.HANDLE_ERROR, closeDropdown);

            window.on('resize.uiAutoCloseDropdown', onClick);
            $document.bind('mousedown.uiAutoCloseDropdown', onClick);
            $document.bind('mousewheel.uiAutoCloseDropdown', onClick);
            $document.bind('DOMMouseScroll.uiAutoCloseDropdown', onClick);
        }, 0);

        $scope.$on('$destroy', function () {
            window.off('resize.uiAutoCloseDropdown', onClick);
            $document.unbind('mousedown.uiAutoCloseDropdown', onClick);
            $document.unbind('mousewheel.uiAutoCloseDropdown', onClick);
            $document.unbind('DOMMouseScroll.uiAutoCloseDropdown', onClick);
        });
    };

    return {
        link: linkFunction,
        restrict: 'E',
        scope: {
            parentClassName: '@',
            dropdownPopoverClassName: '@',
            onClose: '&'
        }
    };
};

angular.module('umCore')
    .directive('umAutoClosePopover', UIAutoClosePopoverDirective);
